import { render } from "./HeaderCompany.vue?vue&type=template&id=bc180058"
import script from "./HeaderCompany.vue?vue&type=script&lang=ts"
export * from "./HeaderCompany.vue?vue&type=script&lang=ts"
script.render = render

export default script